(function () {
  'use strict';

  const CARD_SELECTOR = '.rebuy-product-block';
  const TITLE_SELECTOR = '.rebuy-product-title-link, .rebuy-product-title';
  const ADD_BUTTON_SELECTOR = '.rebuy-product-actions .rebuy-button, .rebuy-button';
  const REBUY_ROOT_SELECTOR = '.rebuy-widget, #rebuy-cart, [id^="rebuy-widget-"]';
  let syncScheduled = false;

  function syncCard(card) {
    const title = String(card.querySelector(TITLE_SELECTOR)?.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!title) return;

    const image = card.querySelector('.rebuy-product-media img, .rebuy-product-image img, img');
    const imageLink = card.querySelector('.rebuy-product-image');
    const titleLink = card.querySelector('.rebuy-product-title-link');
    const addButton = card.querySelector(ADD_BUTTON_SELECTOR);

    if (image) image.alt = title;
    if (imageLink) imageLink.setAttribute('aria-label', `Ver ${title}`);
    if (titleLink) titleLink.setAttribute('aria-label', `Ver ${title}`);
    if (addButton) addButton.setAttribute('aria-label', `Agregar ${title} al carrito`);
  }

  function sync(scope = document) {
    if (scope instanceof Element && scope.matches(CARD_SELECTOR)) syncCard(scope);
    scope.querySelectorAll?.(CARD_SELECTOR).forEach(syncCard);
  }

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    window.requestAnimationFrame(() => {
      syncScheduled = false;
      sync();
    });
  }

  function containsRebuyContent(node) {
    if (!(node instanceof Element)) return false;
    return (
      node.matches(REBUY_ROOT_SELECTOR) ||
      node.matches(CARD_SELECTOR) ||
      Boolean(node.querySelector(`${REBUY_ROOT_SELECTOR}, ${CARD_SELECTOR}`))
    );
  }

  function start() {
    scheduleSync();
    [
      'rebuy:ready',
      'rebuy:widget.ready',
      'rebuy:cart.ready',
      'rebuy:cart.change',
      'rebuy:smartcart.show'
    ].forEach((eventName) => document.addEventListener(eventName, scheduleSync));

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => Array.from(mutation.addedNodes).some(containsRebuyContent))) {
        scheduleSync();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
